import { Injectable } from '@angular/core';

import { ILookup, LookupsService } from 'common';

@Injectable()
export class CountyResolver  {
  constructor(private lookupsService: LookupsService) { }

  resolve() {
    return this.lookupsService.getCounties().toPromise();
  }
}
